import React from "react";
import "./rich-text.scss";
import ReactHtmlParser from "react-html-parser";
const RichText = ({ richText }) => (
  <div className="RichText">{ReactHtmlParser(richText)}</div>
);

export default RichText;
